import React from 'react';
import styled from 'styled-components/macro';
import { Body2, H4, LinkButton } from '../../components/common';
import Card from '../../components/common/Card';
import { ReceiptIcon, TrailingIcon } from '../../assets';
import { Routes } from '../../constants/routes';
import { useMessageGetter } from 'react-message-context';
import { CardContainer } from '../../components/common/CardContainer';

const Container = styled.div`
  margin-top: 40px;
`;

const ResidentCommitteeForms = () => {
  const t = useMessageGetter('forms');

  return (
    <Container id="ResidentCommitteeForms">
      <H4>{t('committee.title')}</H4>
      <Body2>{t('committee.description')}</Body2>
      <CardContainer>
        <Card
          title={t('eventInvite.title')}
          Icon={TrailingIcon}
          secondaryButton={
            <LinkButton to={Routes.ResidentCommittee.EVENT_INVITE} primary size="small">
              {t('eventInvite.create')}
            </LinkButton>
          }
          contentPadding={'6px'}
        />
        <Card
          title={t('meetingMinutes.title')}
          Icon={TrailingIcon}
          secondaryButton={
            <LinkButton to={Routes.ResidentCommittee.MEETING_MINUTES} primary size="small">
              {t('meetingMinutes.create')}
            </LinkButton>
          }
          contentPadding={'6px'}
        />
        <Card
          title={t('actionPlan.title')}
          Icon={TrailingIcon}
          secondaryButton={
            <LinkButton to={Routes.ResidentCommittee.ACTION_PLAN} primary size="small">
              {t('actionPlan.create')}
            </LinkButton>
          }
          contentPadding={'6px'}
        />
        <Card
          title={t('actionReport.title')}
          Icon={TrailingIcon}
          secondaryButton={
            <LinkButton to={Routes.ResidentCommittee.ACTION_REPORT} primary size="small">
              {t('actionReport.create')}
            </LinkButton>
          }
          contentPadding={'6px'}
        />
        <Card
          title={t('generalExpenseReport.title')}
          Icon={ReceiptIcon}
          secondaryButton={
            <LinkButton to={Routes.ResidentCommittee.GENERAL_EXPENSE_REPORT} primary size="small">
              {t('generalExpenseReport.create')}
            </LinkButton>
          }
          contentPadding={'6px'}
        />
        <Card
          title={t('travelExpenseReport.title')}
          Icon={ReceiptIcon}
          secondaryButton={
            <LinkButton to={Routes.ResidentCommittee.TRAVEL_EXPENSE_REPORT} primary size="small">
              {t('travelExpenseReport.create')}
            </LinkButton>
          }
          contentPadding={'6px'}
        />
      </CardContainer>
    </Container>
  );
};

export default ResidentCommitteeForms;
